<div class="home-content" *ngIf="authService.user$ | async as currentUser">

    <div class="page-header-row" *ngIf="contextTitle">
        <h2>{{ contextTitle }}</h2>

        <!-- Manage Trip Members Button -->
        <button mat-stroked-button color="primary" *ngIf="currentTripId" (click)="openTripMembersDialog()">
            <mat-icon>group</mat-icon> Manage Members
        </button>
    </div>

    <!-- Balance Summary Card -->
    <!-- Balance Summary Card -->
    <!-- Modern Compact Summary Card -->
    <div class="summary-card-modern">
        <div class="card-bg-decoration"></div>

        <!-- Header: Label + Date Nav -->
        <div class="card-modern-header">
            <span class="card-label-small">TOTAL SPENT</span>

            <div class="compact-date-nav">
                <button mat-icon-button class="icon-nav-btn" (click)="changeDate(-1)"
                    [disabled]="currentTripId && tripStartDate && date <= (tripStartDate | date:'yyyy-MM-dd')!">
                    <mat-icon>chevron_left</mat-icon>
                </button>
                <span class="nav-date-text">{{ date | date:'MMM d' }}</span>
                <button mat-icon-button class="icon-nav-btn" (click)="changeDate(1)"
                    [disabled]="currentTripId && tripEndDate && date >= (tripEndDate | date:'yyyy-MM-dd')!">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>
        </div>

        <!-- Main Content: Amount + Context -->
        <div class="card-modern-body">
            <div class="amount-wrapper-modern">
                <span class="currency-small">₹</span>
                <span class="amount-large">{{ getTotal() | number:'1.0-0' }}</span>
            </div>
            <div class="daily-context">
                <span class="day-name">{{ date | date:'EEEE' }}</span>
            </div>
        </div>
    </div>

    <!-- Transactions List -->
    <div class="section-card no-bg-card">
        <div class="section-header">
            <div class="header-main">
                <h2>Transactions</h2>
                <span class="swipe-hint">Swipe right to delete, left to edit</span>
            </div>
            <span class="section-badge" *ngIf="currentDayGroup">{{ currentDayGroup.items.length }}</span>
        </div>

        <div *ngIf="expenseService.isLoading" class="loading-state">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>

        <div class="transaction-list" *ngIf="!expenseService.isLoading">
            <div *ngIf="currentDayGroup; else noExpenses">
                <div *ngFor="let exp of currentDayGroup.items" class="swipe-container"
                    (touchstart)="onSwipeStart($event)" (touchend)="onSwipeEnd($event, exp)"
                    (mousedown)="onSwipeStart($event)" (mouseup)="onSwipeEnd($event, exp)">

                    <!-- Swipe Actions -->
                    <div class="swipe-action delete-action" (click)="deleteExpense(exp)"
                        (touchstart)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                        <mat-icon>delete</mat-icon>
                    </div>
                    <div class="swipe-action edit-action" (click)="openExpenseDialog(exp)"
                        (touchstart)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                        <mat-icon>edit</mat-icon>
                    </div>

                    <mat-card class="transaction-item-card" [class.swiped-left]="exp.swiped === 'left'"
                        [class.swiped-right]="exp.swiped === 'right'">
                        <div class="transaction-item-content">
                            <div class="transaction-icon-circle"
                                [style.background-color]="getColorForCategory(exp.category) + '20'"
                                [style.color]="getColorForCategory(exp.category)">
                                <mat-icon>{{ getIconForCategory(exp.category) }}</mat-icon>
                            </div>
                            <div class="transaction-details">
                                <div class="transaction-title">{{ exp.description }}</div>
                                <div class="transaction-meta">{{ exp.category }} • {{ getUserName(exp.user) }}</div>
                            </div>
                            <div class="transaction-right">
                                <span class="transaction-amount">-{{ exp.amount | currency:'INR':'symbol':'1.0-2'
                                    }}</span>
                            </div>
                        </div>
                    </mat-card>
                </div>
            </div>
            <ng-template #noExpenses>
                <div class="empty-state">
                    <mat-icon class="large-empty-icon">note_add</mat-icon>
                    <p>No expenses for this day</p>
                </div>
            </ng-template>
        </div>
    </div>

    <!-- Scoped FAB for Family/Trip Expenses -->
    <button mat-fab class="scoped-fab" color="primary" (click)="openExpenseDialog()"
        [disabled]="currentTripId && currentTripStatus === 'completed'">
        <mat-icon>add</mat-icon>
    </button>

</div>